import Vue from 'vue';
import store from './store';
import App from './App';
import router from './router';
import axios from './server/axios.js';
import port from './server/port.js';
import VueClipboard from 'vue-clipboard2';

//iview 按需加载
import {
    Icon,
    Button,
    Radio,
    RadioGroup,
    Select,
    Switch,
    Option,
    Input,
    Message,
    Modal,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Page,
    Tag,
    Tabs,
    TabPane,
    DatePicker,
    Poptip,
    CheckboxGroup,
    Checkbox,
    Table,
    FormItem,
} from 'iview';
import './style/iview.less';


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.component('Button', Button);
Vue.component('Icon', Icon);
Vue.component('Input', Input);
Vue.component('Radio', Radio);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('i-switch', Switch);
Vue.component('Message', Message);
Vue.component('Modal', Modal);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Page', Page);
Vue.component('Tag', Tag);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('DatePicker', DatePicker);
Vue.component('Poptip', Poptip);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Checkbox', Checkbox);
Vue.component('Table', Table);
Vue.component('FormItem', FormItem);


Vue.config.productionTip = false;
Vue.prototype.$Message = Message;
Vue.prototype.$Modal = Modal;
Vue.prototype.$axios = axios;
Vue.prototype.$port = port;

Vue.use(VueClipboard); //剪切板

//vuex实例
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App,
    },
    template: '<App/>',
});


// WEBPACK FOOTER //
// ./src/main.js